import { CancellablePromise, get } from "@/api";
import type { PrivateProduct } from "@/types";

export function getProducts(): CancellablePromise<PrivateProduct[]> {
  return get(`/v1/products`);
}
